<input type="text" class="input-text" #input [value]="text ? text : null" (blur)="onBlur()">
